var map = {
	"./android.svg": "1ff2",
	"./bootstrap.svg": "38fe",
	"./css3.svg": "44bb",
	"./discord.svg": "f13a",
	"./ethereum.svg": "b366",
	"./firefox.svg": "7060",
	"./git.svg": "3f62",
	"./github.svg": "bbea",
	"./google.svg": "8747",
	"./gradle.svg": "bbeb",
	"./hibernate.svg": "cf43",
	"./html5.svg": "cb40",
	"./intellij-idea.svg": "50e3",
	"./java.svg": "3e2f",
	"./jquery.svg": "8970",
	"./js.svg": "45cd",
	"./kotlin.svg": "231d",
	"./mysql.svg": "7f5a",
	"./postgresql.svg": "0621",
	"./spring.svg": "d496",
	"./tomcat.svg": "d087",
	"./visual-studio-code.svg": "4169",
	"./vue.svg": "0f89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9db";